import React from 'react';
import { capitalize } from 'lodash';
import { TitleWithDescription } from '@infoods/lifebase-ui';

import { GridTableCell } from '../../../../../../shared/components/table-components';

type CustomerCellProps = {
  nickname: string;
  gender: string;
  age: number;
};

const CustomerCell = ({ nickname, gender, age }: CustomerCellProps) => {
  return (
    <GridTableCell>
      <TitleWithDescription
        title={nickname}
        titleFont="body-14-bold"
        description={`${capitalize(gender)}, ${age}`}
      />
    </GridTableCell>
  );
};

export { CustomerCell };
